"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _moment = _interopRequireDefault(require("moment")),
    _classnames = _interopRequireDefault(require("classnames")),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _StatusBar = _interopRequireDefault(require("./StatusBar"));

require("../styles/_credits-overview.scss");

var renderLastMonthStats = (0, _memoizeOne["default"])(function (monthlySubmissions) {
  if (!monthlySubmissions || !monthlySubmissions.length) return null;
  var currentMonth = monthlySubmissions[monthlySubmissions.length - 1],
      lastMonth = monthlySubmissions[monthlySubmissions.length - 2],
      videoSubmissionsDiff = currentMonth.submissions - lastMonth.submissions;
  return _react["default"].createElement("div", {
    className: "credits-overview__last-month-stats"
  }, _react["default"].createElement(_uiKit.Icon, {
    name: 0 <= videoSubmissionsDiff ? "positive" : "negative",
    size: 12,
    color: 0 <= videoSubmissionsDiff ? "monkey" : "redApple"
  }), _react["default"].createElement("p", null, "".concat(Math.abs(videoSubmissionsDiff), " Videos from Last Month")));
}),
    getDaysBeforeExpiry = (0, _memoizeOne["default"])(function () {
  var currentDate = (0, _moment["default"])().date(),
      daysInCurrentMonth = (0, _moment["default"])().daysInMonth();
  return daysInCurrentMonth - currentDate + 1;
});

function CreditsOverview(_ref) {
  var isUnlimited = _ref.isUnlimited,
      creditBalance = _ref.creditBalance,
      monthlySubmissions = _ref.monthlySubmissions,
      size = _ref.size,
      className = _ref.className;
  if (!creditBalance) return null;
  var isSmall = 300 > size.width,
      balance = creditBalance.balance,
      creditTotal = creditBalance.creditTotal,
      rolloverBalance = creditBalance.rolloverBalance,
      rolloverTotal = creditBalance.rolloverTotal,
      balanceToDisplay = isSmall ? balance + rolloverBalance : balance,
      totalToDisplay = isSmall ? creditTotal + rolloverTotal : creditTotal;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])("credits-overview", {
      "credits-overview--unlimited": isUnlimited
    }, {
      "credits-overview--small": isSmall
    }, className)
  }, _react["default"].createElement("div", {
    className: "credits-overview__available"
  }, _react["default"].createElement("p", {
    className: "credits-overview__available__header",
    style: {
      margin: "".concat(isSmall ? "0" : "")
    }
  }, "Available Credits"), _react["default"].createElement("div", {
    className: "credits-overview__available__quantity"
  }, _react["default"].createElement("p", {
    style: {
      fontSize: "".concat(isSmall ? "25px" : ""),
      marginBottom: "".concat(isSmall ? "0" : "")
    }
  }, isUnlimited ? "Unlimited" : "".concat(balanceToDisplay, " of ").concat(totalToDisplay))), isUnlimited ? null : _react["default"].createElement(_StatusBar["default"], {
    balance: balanceToDisplay,
    total: totalToDisplay
  }), renderLastMonthStats(monthlySubmissions)), isUnlimited || isSmall ? null : _react["default"].createElement("div", {
    className: "credits-overview__rollover"
  }, _react["default"].createElement("p", {
    className: "credits-overview__rollover__header"
  }, "Rollover Credits"), _react["default"].createElement("div", {
    className: "credits-overview__rollover__quantity"
  }, _react["default"].createElement("p", null, "".concat(rolloverBalance, " of ").concat(rolloverTotal))), _react["default"].createElement(_StatusBar["default"], {
    balance: rolloverBalance,
    total: rolloverTotal
  }), _react["default"].createElement("p", {
    className: "credits-overview__rollover__expiry"
  }, "Expires in ".concat(getDaysBeforeExpiry(), " days"))));
}

var _default = (0, _react.memo)(CreditsOverview);

exports["default"] = _default;